const menuItems = {
  items: [
    {
      id: 'navigation',
      title: '',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'home',
          title: 'Home Page',
          type: 'item',
          icon: 'feather icon-home text-c-blue',
          url: '/',
          allowedRoles: '*',
          allowedVendors: '*',
          breadcrumbs: true
        },
        {
          id: 'sku',
          title: 'SKU Breakdown',
          type: 'item',
          icon: 'feather icon-file-text text-c-blue',
          url: '/sku-breakdown',
          allowedRoles: ['admin', 'supervisor', 'team-lead', 'senior-team-lead'],
          allowedVendors: 'Supplier',
          breadcrumbs: true
        },
        {
          id: 'orders',
          title: 'Orders',
          type: 'collapse',
          icon: 'feather icon-shopping-cart text-c-blue',
          allowedRoles: '*',
          allowedVendors: '*',
          breadcrumbs: true,
          children: [
            {
              id: 'transfer_orders',
              title: 'Transfer Orders',
              type: 'item',
              url: '/transfer-orders?range=none',
              icon: 'feather icon-log-in text-c-green',
              allowedVendors: 'Warehouse',
              breadcrumbs: true
            },
            {
              id: 'purchase_orders',
              title: 'Purchase Orders',
              type: 'item',
              url: '/purchase-orders?range=none',
              icon: 'feather icon-file-text text-c-blue',
              allowedVendors: '*',
              breadcrumbs: true
            },
            {
              id: 'purchase_receipts',
              title: 'Purchase Receipts',
              type: 'item',
              url: '/purchase-receipts',
              icon: 'feather icon-folder text-c-gray',
              allowedVendors: 'Warehouse',
              breadcrumbs: true
            }
            //,
            // {
            //   id: 'feedback_orders',
            //   title: 'Feedback Orders',
            //   type: 'item',
            //   url: '/feedback-orders?range=none',
            //   icon: 'feather icon-repeat text-c-red',
            //   allowedVendors: 'Warehouse',
            //   breadcrumbs: true
            // }
          ]
        },
        {
          id: 'user_management',
          title: 'User Management ',
          type: 'collapse',
          icon: 'feather icon-users text-c-blue',
          allowedRoles: 'admin',
          allowedVendors: '*',
          breadcrumbs: true,
          children: [
            {
              id: 'user_management_search',
              title: 'Quick Search',
              icon: 'feather icon-search text-c-blue',
              type: 'item',
              url: '/users/search',
              allowedVendors: '*',
              breadcrumbs: true
            },
            {
              id: 'user_management_users',
              title: 'Admin Users',
              icon: 'feather icon-user-check text-c-blue',
              type: 'item',
              url: '/users/management?role=admin',
              allowedVendors: '*',
              breadcrumbs: true
            }
          ]
        },
        {
          id: 'file_management',
          title: 'File Management',
          icon: 'feather icon-file text-c-blue',
          type: 'collapse',
          allowedRoles: 'admin',
          allowedVendors: '*',
          breadcrumbs: true,
          children: [
            {
              id: 'file_management_export',
              title: 'Export POs',
              type: 'item',
              icon: 'feather icon-download text-c-blue',
              url: '/file_management/export',
              allowedVendors: '*',
              breadcrumbs: true
            },
            {
              id: 'file_management_import',
              title: 'Import POs',
              type: 'item',
              icon: 'feather icon-upload text-c-blue',
              url: '/file_management/import',
              allowedVendors: '*',
              breadcrumbs: true
            }
          ]
        },
        {
          id: 'vendor_management',
          title: 'Vendor Management',
          type: 'item',
          icon: 'feather icon-layout text-c-blue',
          url: '/vendor-management',
          allowedRoles: 'admin',
          allowedVendors: '*',
          breadcrumbs: true
        }
      ]
    }
  ]
};

export default menuItems;
